const MCP_SESSION_KEY = 'bagel_mcp_session';

export function persistMcpSession(session: string): void {
  sessionStorage.setItem(MCP_SESSION_KEY, session);
}

export function readMcpSessionFromUrl(
  searchParams: URLSearchParams,
): string | null {
  const fromUrl = searchParams.get('mcp_session')?.trim();
  if (fromUrl) {
    persistMcpSession(fromUrl);
    return fromUrl;
  }
  return sessionStorage.getItem(MCP_SESSION_KEY);
}

export function clearMcpSession(): void {
  sessionStorage.removeItem(MCP_SESSION_KEY);
}

export function getMcpServerUrl(): string | null {
  const url = process.env.REACT_APP_MCP_SERVER_URL?.trim();
  return url ? url.replace(/\/$/, '') : null;
}

/** Android browsers block OAuth popups — use redirect flow instead. */
export function shouldUseGoogleRedirect(): boolean {
  return /Android/i.test(navigator.userAgent);
}
